<template>
    <div class="notification-panel">
        <div class="panel-header">
            <span class="panel-title">알림</span>
            <button v-if="unreadCount > 0" type="button" class="btn-read-all" @click.stop="handleMarkAllRead">
                모두 읽음
            </button>
        </div>
        <div v-if="loading" class="panel-body loading"><i class="fas fa-spinner fa-spin"></i> 로딩 중...</div>
        <div v-else-if="!notifications || notifications.length === 0" class="panel-body empty">알림이 없습니다</div>
        <ul v-else class="notification-list">
            <li
                v-for="item in notifications"
                :key="item.notificationIdx"
                class="notification-item"
                :class="{ unread: !item.isRead }"
                @click="handleItemClick(item)"
            >
                <span class="event-badge">{{ getEventLabel(item.eventType) }}</span>
                <span class="item-title" :title="item.title">{{ truncate(item.title, 40) }}</span>
                <span class="item-date">{{ formatDate(item.sentDate || item.regDate) }}</span>
            </li>
        </ul>
        <div class="panel-footer">
            <button type="button" class="btn-show-all" @click.stop="$emit('show-all')">전체 보기</button>
        </div>
    </div>
</template>

<script>
import CarbonCodes from "@/submodules/carbon-plugin/codes";

export default {
    name: "NotificationPanel",
    props: {
        notifications: { type: Array, default: () => [] },
        unreadCount: { type: Number, default: 0 },
        loading: { type: Boolean, default: false },
    },
    methods: {
        getEventLabel(eventType) {
            return CarbonCodes.eventType.getLabel(eventType) || "-";
        },
        truncate(str, len) {
            if (!str) return "-";
            return str.length <= len ? str : str.slice(0, len) + "…";
        },
        formatDate(val) {
            if (!val) return "-";
            const d = typeof val === "string" ? new Date(val) : val;
            if (isNaN(d.getTime())) return String(val);
            return d.toLocaleString("ko-KR", {
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
        handleItemClick(item) {
            this.$emit("item-click", item);
        },
        handleMarkAllRead() {
            this.$emit("mark-all-read");
        },
    },
};
</script>

<style scoped>
.notification-panel {
    min-width: 320px;
    max-width: 380px;
    max-height: 420px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

.panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    background: #f8fafc;
    flex-shrink: 0;
}

.panel-title {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}

.btn-read-all {
    padding: 4px 10px;
    font-size: 12px;
    font-weight: 500;
    color: #52b788;
    background: transparent;
    border: 1px solid #52b788;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-read-all:hover {
    background: #52b788;
    color: #ffffff;
}

.panel-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
}

.panel-body.loading,
.panel-body.empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    color: #94a3b8;
    font-size: 13px;
}

.notification-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.notification-item {
    padding: 10px 12px;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
    transition: background 0.15s;
    border-radius: 6px;
    margin-bottom: 4px;
}

.notification-item:last-child {
    margin-bottom: 0;
}

.notification-item:hover {
    background: #f8fafc;
}

.notification-item.unread {
    background: #f0fdf4;
}

.notification-item.unread:hover {
    background: #dcfce7;
}

.event-badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 600;
    background: #64748b;
    margin-right: 8px;
    flex-shrink: 0;
}

.item-title {
    font-size: 13px;
    color: #334155;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.item-date {
    display: block;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 4px;
}

.panel-footer {
    padding: 10px 16px;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
    flex-shrink: 0;
}

.btn-show-all {
    width: 100%;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 500;
    color: #52b788;
    background: transparent;
    border: 1px solid #52b788;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-show-all:hover {
    background: #52b788;
    color: #ffffff;
}
</style>
